module.exports = __webpack_public_path__ + "img/55.da9092a0.png";